import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
`;
